import { apiLogin_localToken } from '@/request/api';
import store from '../store'

let timeID = '';
const timer = {
  begin() {
    timeID = setInterval(() => {
      this.get()
    }, 180000)
  },
  get() {
    apiLogin_localToken({ local_token: localStorage.getItem('local_token') }).then(res => {
      sessionStorage.setItem('onlines', JSON.stringify(res.data))
      store.state.online_sum = res.data.online_sum;// 在线人数
      // 公告
      if (!store.state.notice.id) store.state.notice = res.data.notice;
      else if (store.state.notice.id !== res.data.notice.id) store.state.notice = res.data.notice;
      // 系统公告
      if (!store.state.system_notice.id) store.state.system_notice = res.data.system_notice;
      else if (store.state.system_notice.id !== res.data.system_notice.id) store.state.system_notice = res.data.system_notice;
    })
  },
  finish() {
    clearInterval(timeID)
  },
  js() {
    if (sessionStorage.getItem('userToken') && localStorage.getItem('local_token')) {

      if (!timeID) {
        this.get()
        this.begin()

      }

    } else {
      if (timeID) {
        clearInterval(timeID)
        timeID = ''
      }

    }
  }
}

export default timer

